import { gql } from '@apollo/client';

export const FETCH_BATCHES = gql`
  subscription batchDocumentStats($filter: BatchStatusRequestDTO) {
    batchDocumentStats(batchStatusRequestDTO: $filter) {
      statusCode
      status
      page
      id
      dataCount
      data {
        id
        batchName
        batchType
        channelType
        splitType
        envelopeType
        scheduledTime
        approvalType
        approver
        triggeredBy
        totalCount
        initiatedFrom
        status
        createdTime
        requiresApproval
        batchEnd
        processingType
        processingComplete
        approvalCompleted
        printQueueCount
        printCompleteCount
        printInitiated
        languageStats
        deliveryClass
        communicationName
        fileName
        stageNumber
        abortedBy
        abortedTime
        abortedReason
        batchStats {
          id
          channel
          inQueueCount
          successCount
          failureCount
          totalCount
          batchNumber
          status
          createdOn
          unknownCount
          emailSentCount
        }
      }
    }
  }
`;

export const FETCH_BATCH_AUDIT = gql`
  subscription batchAudit($batchId: Int) {
    batchAudit(batchId: $batchId) {
      batchAuditList {
        createdBy
        event
        status
        createdOn
        statusMessage
        email
      }
    }
  }
`;

export const FETCH_HYBRID_AUDIT = gql`
  subscription hybridBatchFullStats($batchId: Int) {
    hybridBatchFullStats(batchId: $batchId) {
      statusCode
      status
      data {
        id
        batchName
        status
        approvalRequired
        approvalType
        createdOn
        counts {
          totalCount
          generatedCount
          generationFailedCount
          sentCount
          releaseFailedCount
          holdCount
          excludedCount
        }
        auditInfo {
          id
          createdBy
          createdByName
          createdByEmail
          createdOn
          status
          metadata
        }
        approvalAuditInfo {
          id
          createdBy
          createdByName
          createdByEmail
          createdOn
          status
          metadata
          statusMessage
          email
        }
      }
    }
  }
`;